module.exports = __webpack_public_path__ + "static/media/prospero-ansty-coventry-warwickshire.1b10893b.jpg";